var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-layout',[_c('div',{staticStyle:{"background":"white"}},[_c('tg-nodata',{attrs:{"isFixing":"","breadcrumb":_vm.breadcrumb}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }